function adjust3columnHeight() {
    const screenWidth = window.innerWidth;
    const threeItemParent = document.querySelector('#over-MA-112');
    const titles = threeItemParent.querySelectorAll('.container-clean-air .promobox .promobox__text_item_1');
    const paras = threeItemParent.querySelectorAll('.container-clean-air .promobox .promobox__text_item_2');
    let titleMaxHeight = 0;
    let paraMaxHeight = 0;
    titles.forEach(title => {
        const titleHeight = title.offsetHeight;
        if (titleHeight > titleMaxHeight) {
            titleMaxHeight = titleHeight;
        }
    });
    paras.forEach(para => {
        const paraHeight = para.offsetHeight;
        if (paraHeight > paraMaxHeight) {
            paraMaxHeight = paraHeight;
        }
    });
    titles.forEach(title => {
        title.style.minHeight = `${titleMaxHeight}px`;
    });
    paras.forEach(para => {
        para.style.minHeight = `${paraMaxHeight}px`;
    });
}
window.addEventListener('resize', adjust3columnHeight);
window.addEventListener('load', adjust3columnHeight);

adjust3columnHeight();
